import React from 'react';
import { Header, Footer } from '../../component/index';

const Download = () => {
    return (
        <>
        <Header homepage={false}/>
<div className="wrapper">
    <div className="container-w-lg">
        <div className="row">
            <img src="static/images/img_banner_download.png" alt="features" width="100%"/>
        </div>
    </div>
    <div className="container-fluid m-b-50">
        <div className="row">
            <div className="col-sm-12">
                <div className="page-title-box p-0 m-t-50">
                    <h4 className="page-title mb-10">Software</h4>
                </div>
            </div>
        </div>
        <div className="flex-container">
            <div className="row">
                <div className="title_underline"></div>
            </div>
        </div>
        <div className="row justify-content-center m-b-50">
            <h4 className="header-title-sm font-16">For all WorldCard Team Version</h4>
        </div>
        <div className="row">
            <div className="col-sm-12 m-b-50 text-center">
                <div className="button-body">
                    <button type="button" className="btn btn-software m-0">Windows</button>
                </div>
                <div className="button-body">
                    <button type="button" className="btn btn-software m-0">Mac</button>
                </div>
                <div className="button-body">
                    <button type="button" className="btn btn-software m-0">iOS</button>
                </div>
                <div className="button-body">
                    <button type="button" className="btn btn-software m-0">Android</button>
                </div>
            </div>
        </div>
    </div>
    <div className="divider-line"></div>
    <div className="container-fluid m-t-20 m-b-50">
        <div className="row">
            <div className="col-sm-12">
                <div className="page-title-box p-0 m-t-50">
                    <h4 className="page-title mb-10">User Manual</h4>
                </div>
            </div>
        </div>
        <div className="flex-container">
            <div className="row">
                <div className="title_underline"></div>
            </div>
        </div>
        <div className="row justify-content-center m-b-50">
            <h4 className="header-title-sm font-16 text-center">若您購買的為NAS及Windows Server 版本， 請參閱手冊， 依指示建置伺服器。</h4>
        </div>
        <div className="row">
            <div className="col-sm-12 m-b-50 text-center">
                <div className="button-body">
                    <button type="button" className="btn btn-manual m-0">Basic Edition</button>
                </div>
                <div className="button-body">
                    <button type="button" className="btn btn-manual m-0">NAS Edition</button>
                </div>
                <div className="button-body">
                    <button type="button" className="btn btn-manual m-0">NAS Basic Edition</button>
                </div>
                <div className="button-body">
                    <button type="button" className="btn btn-manual m-0">Windows Server Edition</button>
                </div>
            </div>
        </div>
    </div>
    <div className="above-footer"></div>
</div>
        <Footer/>
        </>
    )
}

export default Download